import { useQueryApi } from 'utils/api'
import { handleCommonErrors } from 'utils/api'

import type { CommonResponse } from 'typings/api'
import type { OverallProgress } from 'typings/microlearning'

const basePath = '/microlearnings'

export function useGetSingleTopicProgress(
  moduleId: string,
  isTriggered: boolean
) {
  return useQueryApi<
    CommonResponse<OverallProgress, { certifiable?: boolean }>
  >(`${basePath}/topics/${moduleId}/progress`, {
    queryConfig: {
      enabled: !!moduleId && isTriggered,
    },
    errorHandlerFn: (status, path, error) => {
      handleCommonErrors(status ?? 500, path, error)
    },
  })
}
